var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_top"},[_c('div',[_vm._v(_vm._s(_vm.title))]),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ball"},[_c('div'),_c('div')])}]

export { render, staticRenderFns }